import { IntakeCaseGrid } from 'components/intakeCases/IntakeCaseGrid';
import { Grids } from 'store/grids/gridsSlice';

export const MonitoringIntakeCasesGrid = () => (
    <IntakeCaseGrid grid={Grids.MonitoringIntakeCases} />
);
